import React from "react";
import Link from "next/link";
import { isExternalLink } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";

import { OrderItemStatusChip } from "../chips/statusChips/OrderItemStatusChip.jsx";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import LineDivider from "rylak-common/src/components/divider/LineDivider";

const iconWidth = "28px";

function AwesomeIcon({ icon, width = iconWidth }) {
    return <FontAwesomeIcon icon={icon} width={width} style={{ padding: "6px" }} />;
}

export function IconFn({ icon, faIcon, title }) {
    return (
        <TurnrTooltip placement={"top"} content={title}>
            <div
                style={{
                    width: iconWidth,
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                {faIcon ? <AwesomeIcon width={iconWidth} icon={faIcon} /> : icon}
            </div>
        </TurnrTooltip>
    );
}

export default function InfoBox({ items, hideEmptyValues, tight, size = "medium", vertical = false }) {
    const fontSize = size === "small" ? "12px" : "14px";
    const imageSize = size === "small" ? "14px" : "16px";
    const minHeight = size === "small" ? "24px" : "30px";
    return (
        <div
            style={{
                fontSize: imageSize,
                display: "grid",
                gridTemplateColumns: vertical ? "1fr" : tight ? `repeat(auto-fit, minmax(100px, 200px))` : `repeat(auto-fit, minmax(220px, 1fr))`,
                alignItems: "center",
                // gridAutoColumns: 'min-content',
                gridGap: "5px",
            }}
        >
            {items
                ?.filter(({ value }) => !hideEmptyValues || !_.isNil(value))
                ?.map(({ label, value, href, type = "text", renderValueFn, iconFn, icon }, index) => {
                    if (type === "divider") {
                        return <LineDivider key={"divider-" + index} />;
                    }
                    let content =
                        type === "status" ? (
                            <OrderItemStatusChip key={"status-" + index} status={value} />
                        ) : (
                            <div key={"value-" + index} style={{ fontSize }} className={"subtitle"}>
                                <span>{renderValueFn?.(value) || value}</span>
                            </div>
                        );
                    return (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                minHeight: minHeight,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginRight: "5px",
                                }}
                            >
                                {iconFn && iconFn({ value, label })}
                                {icon && <IconFn icon={<AwesomeIcon icon={icon} />} title={label} />}
                            </div>
                            <div
                                style={{
                                    width: "calc(100% - " + iconWidth + ")",
                                }}
                            >
                                {!iconFn && !icon && (
                                    <div className={"subtitle"} style={{ fontSize }}>
                                        {label}
                                    </div>
                                )}
                                {href ? (
                                    <div style={{ width: "fit-content" }}>
                                        <Link href={href} target={isExternalLink(href) ? "_blank" : undefined}>
                                            <span>{content}</span>
                                        </Link>
                                    </div>
                                ) : (
                                    content
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}
